import { atom, useAtomValue } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

/**
 * Q 和 AI 回复关联关系 map
 */
const qaPairQueryAIReplyMsgMapState = atom<Map<string, Set<string>>>(new Map());

export const useQAPairQueryAIReplyMsgMap = () => useAtomValue(qaPairQueryAIReplyMsgMapState);

export const useSetQAPairQueryAIReplyMsgMap = () => {
  return useAtomCallback(
    useCallback((get, set, queryMsgId: string, aiReplyMsgId: string) => {
      const mapValue = get(qaPairQueryAIReplyMsgMapState);
      if (!mapValue.has(queryMsgId)) {
        mapValue.set(queryMsgId, new Set());
      }
      mapValue.get(queryMsgId)?.add(aiReplyMsgId);
      set(qaPairQueryAIReplyMsgMapState, new Map(mapValue));
    }, []),
  );
};

export const useGetQAPairQueryAIReplyMsgMap = () => {
  return useAtomCallback(
    useCallback((get, _, queryMsgId: string) => {
      return get(qaPairQueryAIReplyMsgMapState).get(queryMsgId);
    }, []),
  );
};

export const useClearQAPairQueryAIReplyMsgMap = () => {
  return useAtomCallback(
    useCallback((_, set) => {
      set(qaPairQueryAIReplyMsgMapState, new Map());
    }, []),
  );
};
